import { GetterTree } from 'vuex'
import ConfigsState from '../../types/ConfigsState'
import RootState from '@vue-storefront/core/types/RootState'

const getters: GetterTree<ConfigsState, RootState> = {
  getConfigs: (state) => state.configs,
  getMetaInformation: state => state.configs.filter(config => config.type === 'meta_information'),
  getSeasonalDecoration: state => state.configs.filter(snow => snow.type === 'seasonal_decorations'),
  getGeneralSettings: state => state.configs.filter(snow => snow.type === 'general'),
  getConfigCourierEnrollment: state => state.configs.filter(config => config.type === 'couriers_app'),
  getAllowedCountries: state => state.allowed_countries
}

export default getters
